import React, { FunctionComponent } from 'react';
import InlineMessaging, {
  InlineMessagingTheme,
} from '@havenengineering/module-shared-library/dist/components/InlineMessaging/InlineMessaging';
import { Button } from '@havenengineering/module-shared-owners-ui/dist/components/Button';

type Props = {
  state: Record<string, any>;
  handleSubmit: () => Promise<void>;
  isLoading: boolean;
  isError: boolean;
};

export const SummaryRefund: FunctionComponent<Props> = ({
  state,
  handleSubmit,
  isLoading,
  isError,
}) => {
  return (
    <div>
      <img
        width={45}
        height={45}
        src="/assets/withdraw.svg"
        alt="withdraw icon"
      />
      <p className="owners-body">
        Your are requesting: &nbsp;
        <strong>{`£${state.amount || 400.0}`}</strong>
      </p>
      <hr />
      <p className="owners-body">
        <strong>From:</strong>&nbsp; Haven Account
      </p>
      <p className="owners-body">
        <strong>To:</strong>&nbsp; Account number:{' '}
        {`${state.bankAccountNo.replace(/^.{6}/g, '*****') || ''}`}
      </p>
      <p
        className="owners-body"
        style={{ paddingLeft: 30 }}
      >{`Sort-code: ${state.sortCode}`}</p>

      {isError && (
        <InlineMessaging
          type={InlineMessagingTheme.ERROR_THEME}
          title="Error"
          message="Something went wrong, please try again"
          dismissible={false}
        />
      )}
      <Button fullWidth onClick={() => handleSubmit()} isLoading={isLoading}>
        Submit refund request
      </Button>
      <p className="owners-body">
        When you submit this form we will process your data to enable us to
        manage your request and respond to you. We may also keep a record of
        this communication for an appropriate period of time to assist us when
        managing future communication and to demonstrate how we communicated
        with you. We do this based on our contractual obligations to our owners,
        our legal obligations and our legitimate interests.
        <br />
        Please see our
        <a href="https://www.owner-services.co.uk/support/privacy-policy">
          &nbsp;full privacy policy
        </a>
        &nbsp;for more information on how we process your personal data.
      </p>
    </div>
  );
};
